import { bunja } from 'bunja';
import { atomWithDefault } from 'jotai/utils';

import { abTestBunja } from '@flipster/features/src/shared/ab-test';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

const priceTypes = ['market', 'trigger', 'limit'] as const;
export type PriceType = (typeof priceTypes)[number];

export const commonFormBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { symbolInfoAtom } = bunja.use(tradeSymbolBunja);
  const { getAbFlagAtom } = bunja.use(abTestBunja);

  const isSpotLimitOrderEnabledAtom = getAbFlagAtom('25q4-spot-limit-order', 'on');

  /** Market | Trigger | Limit */
  const priceTypeAtom = atomWithDefault<PriceType>((get) => {
    const symbolInfo = get(symbolInfoAtom);
    const isSpotLimitOrderEnabled = get(isSpotLimitOrderEnabledAtom);
    const prevPriceTypeTab = getLocalStorage('flipster.configs.v1.priceTypeTab');

    const enablesPriceTypes: PriceType[] = (() => {
      if (symbolInfo?.isSpot) {
        if (isSpotLimitOrderEnabled) return ['market', 'trigger', 'limit'];
        return ['market', 'trigger'];
      }
      return ['market', 'trigger', 'limit'];
    })();
    const defaultType: PriceType = enablesPriceTypes.includes('limit') ? 'limit' : 'market';
    const isValidType = prevPriceTypeTab && enablesPriceTypes.some((type) => type === prevPriceTypeTab);

    if (isValidType) return prevPriceTypeTab as PriceType;

    return defaultType;
  });

  bunja.effect(() => {
    const unsubPriceType = store.sub(priceTypeAtom, () => {
      const priceType = store.get(priceTypeAtom);
      setLocalStorage('flipster.configs.v1.priceTypeTab', priceType);
    });

    return () => {
      unsubPriceType();
    };
  });

  return {
    priceTypeAtom,
  };
});
commonFormBunja.debugLabel = 'commonFormBunja';
